import React from 'react';
import {Box, Heading, HStack, Text, VStack} from 'native-base';
import {stripedColors} from '../../../../../constants/ui/colors';
import {formatNumber} from '../../../../../utils/format';

type FeePaymentDetailItemType = {
  label: string;
  amount: number;
  isEven: boolean;
};

export const FeePaymentDetailItem = (props: FeePaymentDetailItemType) => {
  const {label, amount, isEven} = props;

  return (
    <HStack
      width="100%"
      paddingY={3}
      paddingX={5}
      backgroundColor={isEven ? stripedColors.even : stripedColors.odd}>
      <VStack flex={1}>
        <HStack space={5}>
          <VStack justifyContent="center" space="0" flex={1}>
            <Box height="5" justifyContent="center">
              <Heading size="sm" fontWeight="bold" color="black">
                {label}
              </Heading>
            </Box>
          </VStack>
          <HStack w="200">
            <VStack justifyContent="flex-end" space="1" w={'200'}>
              <Box height="5" alignItems={'flex-end'} paddingLeft="2">
                <Text fontWeight="bold" color="#06355E">
                  {formatNumber(amount)}
                </Text>
              </Box>
            </VStack>
          </HStack>
        </HStack>
      </VStack>
    </HStack>
  );
};
